import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/Login';
import CarsTable from './components/CarsTable';
import SmsBoard from './components/SmsBoard';
import DamagedBoard from './components/DamagedBoard';
import FirstOwnerBoard from './components/FirstOwnerBoard';
import GebrauchtwagenBoard from './components/GebrauchtwagenBoard';
import AdminPanel from './components/AdminPanel';
import DealersAdminPanel from './components/DealersAdminPanel';
import PrivateRoute from './components/PrivateRoute';
import EndUserLogin from './components/EndUserLogin';
import EndUserLayout from './components/EndUserLayout';
import EndUserCars from './components/EndUserCars';
import EndUserHome from './components/EndUserHome';
import EndUserDamaged from './components/EndUserDamaged';
import EndUserFirstOwner from './components/EndUserFirstOwner';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <PrivateRoute>
              <CarsTable />
            </PrivateRoute>
          } />
          <Route path="/sms" element={
            <PrivateRoute>
              <SmsBoard />
            </PrivateRoute>
          } />
          <Route path="/v-okvari" element={
            <PrivateRoute>
              <DamagedBoard />
            </PrivateRoute>
          } />
          <Route path="/prvi-lastnik" element={
            <PrivateRoute>
              <FirstOwnerBoard />
            </PrivateRoute>
          } />
          <Route path="/gebrauchtwagen" element={
            <PrivateRoute>
              <GebrauchtwagenBoard />
            </PrivateRoute>
          } />
          <Route path="/admin" element={
            <PrivateRoute>
              <AdminPanel />
            </PrivateRoute>
          } />
          <Route path="/dealers" element={
            <PrivateRoute>
              <DealersAdminPanel />
            </PrivateRoute>
          } />
          {/* End-user PWA: enotna app z zavihki (Avtomobili / Obvestila / SMS) — skupna prijava */}
          <Route path="/app/prijava" element={<EndUserLogin />} />
          <Route path="/app" element={<EndUserLayout />}>
            <Route index element={<EndUserCars />} />
            <Route path="filter" element={<EndUserHome />} />
            <Route path="v-okvari" element={<EndUserDamaged />} />
            <Route path="prvi-lastnik" element={<EndUserFirstOwner />} />
            <Route path="sms" element={<SmsBoard embedded />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;